// IPL 2026 - Squad Data for all 10 teams
// Photos: only IDs confirmed downloaded in /ipl_photos/ are set
// All others use null → PlayerAvatar shows initials with team color
// Role: BAT | BOWL | AR | WK

const BASE = "/ipl_photos/";
const p = (id) => `${BASE}${id}.png`;
const NONE = null; // no photo downloaded yet

const VERIFIED_IDS = {
  // These files exist in /ipl_photos/ — confirmed April 2026
  "Ravindra Jadeja":    p(9),
  "Ishant Sharma":      p(44),
  "Bhuvneshwar Kumar":  p(116),   // verify visually after fix
  "Deepak Chahar":      p(140),
  "Harshal Patel":      p(157),
  "Virat Kohli":        p(164),
  "Sunil Narine":       p(203),
  "Matthew Short":      p(2032),
  "Heinrich Klaasen":   p(3869),
};

function photo(playerName) {
  return VERIFIED_IDS[playerName] || NONE;
}

const PLAYERS_DATA = {
  CSK: {
    name: "Chennai Super Kings",
    shortName: "CSK",
    color: "#F9CD1C",
    textColor: "#1A1A1A",
    players: [
      { name: "Ruturaj Gaikwad",    role: "BAT",  photo: photo("Ruturaj Gaikwad")    },
      { name: "MS Dhoni",           role: "WK",   photo: photo("MS Dhoni")            },
      { name: "Sanju Samson",       role: "WK",   photo: photo("Sanju Samson")        },
      { name: "Dewald Brevis",      role: "BAT",  photo: photo("Dewald Brevis")       },
      { name: "Ayush Mhatre",       role: "BAT",  photo: photo("Ayush Mhatre")        },
      { name: "Kartik Sharma",      role: "WK",   photo: photo("Kartik Sharma")       },
      { name: "Sarfaraz Khan",      role: "BAT",  photo: photo("Sarfaraz Khan")       },
      { name: "Urvil Patel",        role: "WK",   photo: photo("Urvil Patel")         },
      { name: "Jamie Overton",      role: "AR",   photo: photo("Jamie Overton")       },
      { name: "Ramakrishna Ghosh",  role: "AR",   photo: photo("Ramakrishna Ghosh")   },
      { name: "Prashant Veer",      role: "AR",   photo: photo("Prashant Veer")       },
      { name: "Matthew Short",      role: "AR",   photo: photo("Matthew Short")       },
      { name: "Aman Khan",          role: "AR",   photo: photo("Aman Khan")           },
      { name: "Zak Foulkes",        role: "AR",   photo: photo("Zak Foulkes")         },
      { name: "Shivam Dube",        role: "AR",   photo: photo("Shivam Dube")         },
      { name: "Khaleel Ahmed",      role: "BOWL", photo: photo("Khaleel Ahmed")       },
      { name: "Noor Ahmad",         role: "BOWL", photo: photo("Noor Ahmad")          },
      { name: "Anshul Kamboj",      role: "BOWL", photo: photo("Anshul Kamboj")       },
      { name: "Mukesh Choudhary",   role: "BOWL", photo: photo("Mukesh Choudhary")    },
      { name: "Shreyas Gopal",      role: "BOWL", photo: photo("Shreyas Gopal")       },
      { name: "Gurjapneet Singh",   role: "BOWL", photo: photo("Gurjapneet Singh")    },
      { name: "Akeal Hosein",       role: "BOWL", photo: photo("Akeal Hosein")        },
      { name: "Matt Henry",         role: "BOWL", photo: photo("Matt Henry")          },
      { name: "Rahul Chahar",       role: "BOWL", photo: photo("Rahul Chahar")        },
      { name: "Spencer Johnson",    role: "BOWL", photo: photo("Spencer Johnson")     },
    ],
  },

  MI: {
    name: "Mumbai Indians",
    shortName: "MI",
    color: "#004BA0",
    textColor: "#FFFFFF",
    players: [
      { name: "Rohit Sharma",        role: "BAT",  photo: photo("Rohit Sharma")        },
      { name: "Suryakumar Yadav",    role: "BAT",  photo: photo("Suryakumar Yadav")    },
      { name: "Robin Minz",          role: "WK",   photo: photo("Robin Minz")          },
      { name: "Sherfane Rutherford", role: "BAT",  photo: photo("Sherfane Rutherford") },
      { name: "Ryan Rickelton",      role: "WK",   photo: photo("Ryan Rickelton")      },
      { name: "Quinton de Kock",     role: "WK",   photo: photo("Quinton de Kock")     },
      { name: "Danish Malewar",      role: "BAT",  photo: photo("Danish Malewar")      },
      { name: "Tilak Varma",         role: "BAT",  photo: photo("Tilak Varma")         },
      { name: "Hardik Pandya",       role: "AR",   photo: photo("Hardik Pandya")       },
      { name: "Naman Dhir",          role: "AR",   photo: photo("Naman Dhir")          },
      { name: "Mitchell Santner",    role: "AR",   photo: photo("Mitchell Santner")    },
      { name: "Raj Angad Bawa",      role: "AR",   photo: photo("Raj Angad Bawa")      },
      { name: "Atharva Ankolekar",   role: "AR",   photo: photo("Atharva Ankolekar")   },
      { name: "Mayank Rawat",        role: "AR",   photo: photo("Mayank Rawat")        },
      { name: "Corbin Bosch",        role: "AR",   photo: photo("Corbin Bosch")        },
      { name: "Will Jacks",          role: "AR",   photo: photo("Will Jacks")          },
      { name: "Shardul Thakur",      role: "AR",   photo: photo("Shardul Thakur")      },
      { name: "Trent Boult",         role: "BOWL", photo: photo("Trent Boult")         },
      { name: "Mayank Markande",     role: "BOWL", photo: photo("Mayank Markande")     },
      { name: "Deepak Chahar",       role: "BOWL", photo: photo("Deepak Chahar")       },
      { name: "Ashwani Kumar",       role: "BOWL", photo: photo("Ashwani Kumar")       },
      { name: "Raghu Sharma",        role: "BOWL", photo: photo("Raghu Sharma")        },
      { name: "Mohammad Izhar",      role: "BOWL", photo: photo("Mohammad Izhar")      },
      { name: "Allah Ghazanfar",     role: "BOWL", photo: photo("Allah Ghazanfar")     },
      { name: "Jasprit Bumrah",      role: "BOWL", photo: photo("Jasprit Bumrah")      },
    ],
  },

  RCB: {
    name: "Royal Challengers Bengaluru",
    shortName: "RCB",
    color: "#EC1C24",
    textColor: "#FFFFFF",
    players: [
      { name: "Rajat Patidar",      role: "BAT",  photo: photo("Rajat Patidar")      },
      { name: "Devdutt Padikkal",   role: "BAT",  photo: photo("Devdutt Padikkal")   },
      { name: "Virat Kohli",        role: "BAT",  photo: photo("Virat Kohli")        },
      { name: "Phil Salt",          role: "WK",   photo: photo("Phil Salt")          },
      { name: "Jitesh Sharma",      role: "WK",   photo: photo("Jitesh Sharma")      },
      { name: "Jordan Cox",         role: "WK",   photo: photo("Jordan Cox")         },
      { name: "Krunal Pandya",      role: "AR",   photo: photo("Krunal Pandya")      },
      { name: "Swapnil Singh",      role: "AR",   photo: photo("Swapnil Singh")      },
      { name: "Tim David",          role: "AR",   photo: photo("Tim David")          },
      { name: "Romario Shepherd",   role: "AR",   photo: photo("Romario Shepherd")   },
      { name: "Jacob Bethell",      role: "AR",   photo: photo("Jacob Bethell")      },
      { name: "Venkatesh Iyer",     role: "AR",   photo: photo("Venkatesh Iyer")     },
      { name: "Satvik Deswal",      role: "AR",   photo: photo("Satvik Deswal")      },
      { name: "Mangesh Yadav",      role: "AR",   photo: photo("Mangesh Yadav")      },
      { name: "Vicky Ostwal",       role: "AR",   photo: photo("Vicky Ostwal")       },
      { name: "Vihaan Malhotra",    role: "AR",   photo: photo("Vihaan Malhotra")    },
      { name: "Kanishk Chouhan",    role: "AR",   photo: photo("Kanishk Chouhan")    },
      { name: "Josh Hazlewood",     role: "BOWL", photo: photo("Josh Hazlewood")     },
      { name: "Rasikh Dar",         role: "BOWL", photo: photo("Rasikh Dar")         },
      { name: "Suyash Sharma",      role: "BOWL", photo: photo("Suyash Sharma")      },
      { name: "Bhuvneshwar Kumar",  role: "BOWL", photo: photo("Bhuvneshwar Kumar")  },
      { name: "Nuwan Thushara",     role: "BOWL", photo: photo("Nuwan Thushara")     },
      { name: "Abhinandan Singh",   role: "BOWL", photo: photo("Abhinandan Singh")   },
      { name: "Jacob Duffy",        role: "BOWL", photo: photo("Jacob Duffy")        },
      { name: "Yash Dayal",         role: "BOWL", photo: photo("Yash Dayal")         },
    ],
  },

  KKR: {
    name: "Kolkata Knight Riders",
    shortName: "KKR",
    color: "#3A225D",
    textColor: "#F2C94C",
    players: [
      { name: "Ajinkya Rahane",       role: "BAT",  photo: photo("Ajinkya Rahane")       },
      { name: "Rinku Singh",          role: "BAT",  photo: photo("Rinku Singh")          },
      { name: "Angkrish Raghuvanshi", role: "BAT",  photo: photo("Angkrish Raghuvanshi") },
      { name: "Manish Pandey",        role: "BAT",  photo: photo("Manish Pandey")        },
      { name: "Cameron Green",        role: "BAT",  photo: photo("Cameron Green")        },
      { name: "Finn Allen",           role: "WK",   photo: photo("Finn Allen")           },
      { name: "Rahul Tripathi",       role: "BAT",  photo: photo("Rahul Tripathi")       },
      { name: "Tim Seifert",          role: "WK",   photo: photo("Tim Seifert")          },
      { name: "Rovman Powell",        role: "BAT",  photo: photo("Rovman Powell")        },
      { name: "Anukul Roy",           role: "AR",   photo: photo("Anukul Roy")           },
      { name: "Rachin Ravindra",      role: "AR",   photo: photo("Rachin Ravindra")      },
      { name: "Ramandeep Singh",      role: "AR",   photo: photo("Ramandeep Singh")      },
      { name: "Vaibhav Arora",        role: "BOWL", photo: photo("Vaibhav Arora")        },
      { name: "Matheesha Pathirana",  role: "BOWL", photo: photo("Matheesha Pathirana")  },
      { name: "Kartik Tyagi",         role: "BOWL", photo: photo("Kartik Tyagi")         },
      { name: "Prashant Solanki",     role: "BOWL", photo: photo("Prashant Solanki")     },
      { name: "Akash Deep",           role: "BOWL", photo: photo("Akash Deep")           },
      { name: "Harshit Rana",         role: "BOWL", photo: photo("Harshit Rana")         },
      { name: "Umran Malik",          role: "BOWL", photo: photo("Umran Malik")          },
      { name: "Sunil Narine",         role: "BOWL", photo: photo("Sunil Narine")         },
      { name: "Varun Chakravarthy",   role: "BOWL", photo: photo("Varun Chakravarthy")   },
    ],
  },

  SRH: {
    name: "Sunrisers Hyderabad",
    shortName: "SRH",
    color: "#F26522",
    textColor: "#FFFFFF",
    players: [
      { name: "Ishan Kishan",        role: "WK",   photo: photo("Ishan Kishan")        },
      { name: "Aniket Verma",        role: "BAT",  photo: photo("Aniket Verma")        },
      { name: "Smaran Ravichandran", role: "BAT",  photo: photo("Smaran Ravichandran") },
      { name: "Salil Arora",         role: "WK",   photo: photo("Salil Arora")         },
      { name: "Heinrich Klaasen",    role: "WK",   photo: photo("Heinrich Klaasen")    },
      { name: "Travis Head",         role: "BAT",  photo: photo("Travis Head")         },
      { name: "Harshal Patel",       role: "AR",   photo: photo("Harshal Patel")       },
      { name: "Kamindu Mendis",      role: "AR",   photo: photo("Kamindu Mendis")      },
      { name: "Harsh Dubey",         role: "AR",   photo: photo("Harsh Dubey")         },
      { name: "Brydon Carse",        role: "AR",   photo: photo("Brydon Carse")        },
      { name: "Shivang Kumar",       role: "AR",   photo: photo("Shivang Kumar")       },
      { name: "Liam Livingstone",    role: "AR",   photo: photo("Liam Livingstone")    },
      { name: "Jack Edwards",        role: "AR",   photo: photo("Jack Edwards")        },
      { name: "Abhishek Sharma",     role: "AR",   photo: photo("Abhishek Sharma")     },
      { name: "Nitish Kumar Reddy",  role: "AR",   photo: photo("Nitish Kumar Reddy")  },
      { name: "Pat Cummins",         role: "BOWL", photo: photo("Pat Cummins")         },
      { name: "Zeeshan Ansari",      role: "BOWL", photo: photo("Zeeshan Ansari")      },
      { name: "Jaydev Unadkat",      role: "BOWL", photo: photo("Jaydev Unadkat")      },
      { name: "Shivam Mavi",         role: "BOWL", photo: photo("Shivam Mavi")         },
    ],
  },

  DC: {
    name: "Delhi Capitals",
    shortName: "DC",
    color: "#00008B",
    textColor: "#FFFFFF",
    players: [
      { name: "KL Rahul",            role: "WK",   photo: photo("KL Rahul")            },
      { name: "Karun Nair",          role: "BAT",  photo: photo("Karun Nair")          },
      { name: "David Miller",        role: "BAT",  photo: photo("David Miller")        },
      { name: "Ben Duckett",         role: "WK",   photo: photo("Ben Duckett")         },
      { name: "Pathum Nissanka",     role: "BAT",  photo: photo("Pathum Nissanka")     },
      { name: "Sahil Parakh",        role: "BAT",  photo: photo("Sahil Parakh")        },
      { name: "Prithvi Shaw",        role: "BAT",  photo: photo("Prithvi Shaw")        },
      { name: "Abishek Porel",       role: "WK",   photo: photo("Abishek Porel")       },
      { name: "Tristan Stubbs",      role: "WK",   photo: photo("Tristan Stubbs")      },
      { name: "Axar Patel",          role: "AR",   photo: photo("Axar Patel")          },
      { name: "Sameer Rizvi",        role: "AR",   photo: photo("Sameer Rizvi")        },
      { name: "Ashutosh Sharma",     role: "AR",   photo: photo("Ashutosh Sharma")     },
      { name: "Vipraj Nigam",        role: "AR",   photo: photo("Vipraj Nigam")        },
      { name: "Ajay Mandal",         role: "AR",   photo: photo("Ajay Mandal")         },
      { name: "Tripurana Vijay",     role: "AR",   photo: photo("Tripurana Vijay")     },
      { name: "Madhav Tiwari",       role: "AR",   photo: photo("Madhav Tiwari")       },
      { name: "Auqib Dar",           role: "AR",   photo: photo("Auqib Dar")           },
      { name: "Nitish Rana",         role: "AR",   photo: photo("Nitish Rana")         },
      { name: "Mitchell Starc",      role: "BOWL", photo: photo("Mitchell Starc")      },
      { name: "T. Natarajan",        role: "BOWL", photo: photo("T. Natarajan")        },
      { name: "Mukesh Kumar",        role: "BOWL", photo: photo("Mukesh Kumar")        },
      { name: "Dushmantha Chameera", role: "BOWL", photo: photo("Dushmantha Chameera") },
      { name: "Lungi Ngidi",         role: "BOWL", photo: photo("Lungi Ngidi")         },
      { name: "Kyle Jamieson",       role: "BOWL", photo: photo("Kyle Jamieson")       },
      { name: "Kuldeep Yadav",       role: "BOWL", photo: photo("Kuldeep Yadav")       },
    ],
  },

  LSG: {
    name: "Lucknow Super Giants",
    shortName: "LSG",
    color: "#A72056",
    textColor: "#FFFFFF",
    players: [
      { name: "Rishabh Pant",        role: "WK",   photo: photo("Rishabh Pant")        },
      { name: "Aiden Markram",       role: "BAT",  photo: photo("Aiden Markram")       },
      { name: "Himmat Singh",        role: "BAT",  photo: photo("Himmat Singh")        },
      { name: "Matthew Breetzke",    role: "BAT",  photo: photo("Matthew Breetzke")    },
      { name: "Mukul Choudhary",     role: "WK",   photo: photo("Mukul Choudhary")     },
      { name: "Akshat Raghuwanshi",  role: "BAT",  photo: photo("Akshat Raghuwanshi")  },
      { name: "Josh Inglis",         role: "WK",   photo: photo("Josh Inglis")         },
      { name: "Nicholas Pooran",     role: "WK",   photo: photo("Nicholas Pooran")     },
      { name: "Mitchell Marsh",      role: "AR",   photo: photo("Mitchell Marsh")      },
      { name: "Abdul Samad",         role: "AR",   photo: photo("Abdul Samad")         },
      { name: "Shahbaz Ahmed",       role: "AR",   photo: photo("Shahbaz Ahmed")       },
      { name: "Arshin Kulkarni",     role: "AR",   photo: photo("Arshin Kulkarni")     },
      { name: "Wanindu Hasaranga",   role: "AR",   photo: photo("Wanindu Hasaranga")   },
      { name: "Ayush Badoni",        role: "AR",   photo: photo("Ayush Badoni")        },
      { name: "Mohammad Shami",      role: "BOWL", photo: photo("Mohammad Shami")      },
      { name: "Avesh Khan",          role: "BOWL", photo: photo("Avesh Khan")          },
      { name: "M. Siddharth",        role: "BOWL", photo: photo("M. Siddharth")        },
      { name: "Digvesh Singh",       role: "BOWL", photo: photo("Digvesh Singh")       },
      { name: "Akash Singh",         role: "BOWL", photo: photo("Akash Singh")         },
      { name: "Prince Yadav",        role: "BOWL", photo: photo("Prince Yadav")        },
      { name: "Arjun Tendulkar",     role: "BOWL", photo: photo("Arjun Tendulkar")     },
      { name: "Anrich Nortje",       role: "BOWL", photo: photo("Anrich Nortje")       },
      { name: "Naman Tiwari",        role: "BOWL", photo: photo("Naman Tiwari")        },
      { name: "Mayank Yadav",        role: "BOWL", photo: photo("Mayank Yadav")        },
      { name: "Mohsin Khan",         role: "BOWL", photo: photo("Mohsin Khan")         },
    ],
  },

  RR: {
    name: "Rajasthan Royals",
    shortName: "RR",
    color: "#254AA5",
    textColor: "#FFFFFF",
    players: [
      { name: "Riyan Parag",          role: "BAT",  photo: photo("Riyan Parag")          },
      { name: "Shubham Dubey",        role: "BAT",  photo: photo("Shubham Dubey")        },
      { name: "Vaibhav Suryavanshi",  role: "BAT",  photo: photo("Vaibhav Suryavanshi")  },
      { name: "Donovan Ferreira",     role: "WK",   photo: photo("Donovan Ferreira")     },
      { name: "Lhuan-dre Pretorius",  role: "BAT",  photo: photo("Lhuan-dre Pretorius")  },
      { name: "Shimron Hetmyer",      role: "BAT",  photo: photo("Shimron Hetmyer")      },
      { name: "Yashasvi Jaiswal",     role: "BAT",  photo: photo("Yashasvi Jaiswal")     },
      { name: "Dhruv Jurel",          role: "WK",   photo: photo("Dhruv Jurel")          },
      { name: "Yudhvir Singh Charak", role: "AR",   photo: photo("Yudhvir Singh Charak") },
      { name: "Ravindra Jadeja",      role: "AR",   photo: photo("Ravindra Jadeja")      },
      { name: "Sam Curran",           role: "AR",   photo: photo("Sam Curran")           },
      { name: "Jofra Archer",         role: "BOWL", photo: photo("Jofra Archer")         },
      { name: "Tushar Deshpande",     role: "BOWL", photo: photo("Tushar Deshpande")     },
      { name: "Kwena Maphaka",        role: "BOWL", photo: photo("Kwena Maphaka")        },
      { name: "Ravi Bishnoi",         role: "BOWL", photo: photo("Ravi Bishnoi")         },
      { name: "Sushant Mishra",       role: "BOWL", photo: photo("Sushant Mishra")       },
      { name: "Vignesh Puthur",       role: "BOWL", photo: photo("Vignesh Puthur")       },
      { name: "Adam Milne",           role: "BOWL", photo: photo("Adam Milne")           },
      { name: "Kuldeep Sen",          role: "BOWL", photo: photo("Kuldeep Sen")          },
      { name: "Sandeep Sharma",       role: "BOWL", photo: photo("Sandeep Sharma")       },
      { name: "Nandre Burger",        role: "BOWL", photo: photo("Nandre Burger")        },
    ],
  },

  PBKS: {
    name: "Punjab Kings",
    shortName: "PBKS",
    color: "#ED1F27",
    textColor: "#FFFFFF",
    players: [
      { name: "Shreyas Iyer",       role: "BAT",  photo: photo("Shreyas Iyer")       },
      { name: "Nehal Wadhera",      role: "BAT",  photo: photo("Nehal Wadhera")      },
      { name: "Prabhsimran Singh",  role: "WK",   photo: photo("Prabhsimran Singh")  },
      { name: "Vishnu Vinod",       role: "WK",   photo: photo("Vishnu Vinod")       },
      { name: "Harnoor Pannu",      role: "BAT",  photo: photo("Harnoor Pannu")      },
      { name: "Pyla Avinash",       role: "BAT",  photo: photo("Pyla Avinash")       },
      { name: "Shashank Singh",     role: "BAT",  photo: photo("Shashank Singh")     },
      { name: "Marcus Stoinis",     role: "AR",   photo: photo("Marcus Stoinis")     },
      { name: "Harpreet Brar",      role: "AR",   photo: photo("Harpreet Brar")      },
      { name: "Marco Jansen",       role: "AR",   photo: photo("Marco Jansen")       },
      { name: "Azmatullah Omarzai", role: "AR",   photo: photo("Azmatullah Omarzai") },
      { name: "Priyansh Arya",      role: "AR",   photo: photo("Priyansh Arya")      },
      { name: "Musheer Khan",       role: "AR",   photo: photo("Musheer Khan")       },
      { name: "Suryansh Shedge",    role: "AR",   photo: photo("Suryansh Shedge")    },
      { name: "Mitch Owen",         role: "AR",   photo: photo("Mitch Owen")         },
      { name: "Cooper Connolly",    role: "AR",   photo: photo("Cooper Connolly")    },
      { name: "Ben Dwarshuis",      role: "AR",   photo: photo("Ben Dwarshuis")      },
      { name: "Arshdeep Singh",     role: "BOWL", photo: photo("Arshdeep Singh")     },
      { name: "Yuzvendra Chahal",   role: "BOWL", photo: photo("Yuzvendra Chahal")   },
      { name: "Lockie Ferguson",    role: "BOWL", photo: photo("Lockie Ferguson")    },
      { name: "Xavier Bartlett",    role: "BOWL", photo: photo("Xavier Bartlett")    },
      { name: "Vyshak Vijaykumar",  role: "BOWL", photo: photo("Vyshak Vijaykumar")  },
      { name: "Yash Thakur",        role: "BOWL", photo: photo("Yash Thakur")        },
      { name: "Pravin Dubey",       role: "BOWL", photo: photo("Pravin Dubey")       },
      { name: "Vishal Nishad",      role: "BOWL", photo: photo("Vishal Nishad")      },
    ],
  },

  GT: {
    name: "Gujarat Titans",
    shortName: "GT",
    color: "#1C1C1C",
    textColor: "#D4AF37",
    players: [
      { name: "Shubman Gill",       role: "BAT",  photo: photo("Shubman Gill")       },
      { name: "Jos Buttler",        role: "WK",   photo: photo("Jos Buttler")        },
      { name: "Kumar Kushagra",     role: "WK",   photo: photo("Kumar Kushagra")     },
      { name: "Anuj Rawat",         role: "WK",   photo: photo("Anuj Rawat")         },
      { name: "Tom Banton",         role: "WK",   photo: photo("Tom Banton")         },
      { name: "Glenn Phillips",     role: "BAT",  photo: photo("Glenn Phillips")     },
      { name: "Sai Sudharsan",      role: "BAT",  photo: photo("Sai Sudharsan")      },
      { name: "Shahrukh Khan",      role: "BAT",  photo: photo("Shahrukh Khan")      },
      { name: "Rashid Khan",        role: "AR",   photo: photo("Rashid Khan")        },
      { name: "Washington Sundar",  role: "AR",   photo: photo("Washington Sundar")  },
      { name: "Nishant Sindhu",     role: "AR",   photo: photo("Nishant Sindhu")     },
      { name: "Mohd. Arshad Khan",  role: "AR",   photo: photo("Mohd. Arshad Khan")  },
      { name: "Sai Kishore",        role: "AR",   photo: photo("Sai Kishore")        },
      { name: "Jayant Yadav",       role: "AR",   photo: photo("Jayant Yadav")       },
      { name: "Jason Holder",       role: "AR",   photo: photo("Jason Holder")       },
      { name: "Rahul Tewatia",      role: "AR",   photo: photo("Rahul Tewatia")      },
      { name: "Kagiso Rabada",      role: "BOWL", photo: photo("Kagiso Rabada")      },
      { name: "Mohammed Siraj",     role: "BOWL", photo: photo("Mohammed Siraj")     },
      { name: "Prasidh Krishna",    role: "BOWL", photo: photo("Prasidh Krishna")    },
      { name: "Ishant Sharma",      role: "BOWL", photo: photo("Ishant Sharma")      },
      { name: "Mohit Sharma",       role: "BOWL", photo: photo("Mohit Sharma")       },
      { name: "Abhinav Manohar",    role: "BAT",  photo: photo("Abhinav Manohar")    },
      { name: "Ashok Sharma",       role: "BOWL", photo: photo("Ashok Sharma")       },
      { name: "Luke Wood",          role: "BOWL", photo: photo("Luke Wood")          },
    ],
  },
};

export function getTeamPlayers(teamCode) {
  return PLAYERS_DATA[teamCode]?.players || [];
}

export function getMatchPlayers(team1Code, team2Code) {
  const t1 = PLAYERS_DATA[team1Code];
  const t2 = PLAYERS_DATA[team2Code];
  return {
    team1: { ...t1, code: team1Code },
    team2: { ...t2, code: team2Code },
    allPlayers: [
      ...(t1?.players || []).map(p => ({ ...p, team: team1Code, teamName: t1?.shortName })),
      ...(t2?.players || []).map(p => ({ ...p, team: team2Code, teamName: t2?.shortName })),
    ],
  };
}

export function getRoleLabel(role) {
  return { BAT: "Batsman", BOWL: "Bowler", AR: "All-Rounder", WK: "Wicketkeeper" }[role] || role;
}

export function getRoleColor(role) {
  return { BAT: "#1D9E75", BOWL: "#E24B4A", AR: "#7F77DD", WK: "#F5A623" }[role] || "#888780";
}

export default PLAYERS_DATA;